var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos-container"},[_c('posFnBHeader',{attrs:{"isLogin":true}}),_vm._v(" "),_c('div',{staticClass:"cash-given-container"},[_c('PosCashCalculator',{attrs:{"nextRoute":"pos-fnb"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ac1ef4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PosFnbContainer/posFnbCashInput.vue
// module id = null
// module chunks = 